export const CHECKBOX = 'CHECKBOX';
const NAME = 'NAME';
const CREATED_BY = 'CREATED_BY';
const CREATED_AT = 'CREATED_AT';
export const TAG_MANAGER_TABLE_COLUMNS = [{
  key: NAME,
  labelKey: 'reports.tagManager.table.header.name',
  sortable: true,
  width: '420px'
}, {
  key: CREATED_BY,
  labelKey: 'reports.tagManager.table.header.createdBy',
  sortable: true,
  width: '200px'
}, {
  key: CREATED_AT,
  labelKey: 'reports.tagManager.table.header.createdAt',
  sortable: true,
  width: '200px'
}];